export default __webpack_public_path__ + "static/media/VD5.3114d838.png";